module.exports = __webpack_public_path__ + "static/media/log_active.d2de2f62.svg";